import { useContext, useEffect, useState } from "react";
import { collection, doc, getDocs, orderBy, query, updateDoc } from "firebase/firestore";
import { db } from "../firebase/config";
import { AuthContext } from "../AuthContext";

export default function AdminUsers() {
  const { user, isAdmin, loading: authLoading } = useContext(AuthContext);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (authLoading || !isAdmin) {
      setLoading(false);
      return;
    }

    const loadUsers = async () => {
      setLoading(true);
      setError("");
      try {
        const q = query(collection(db, "users"), orderBy("email", "asc"));
        const snap = await getDocs(q);
        setUsers(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      } catch (err) {
        console.error(err);
        setError("Failed to load users.");
      } finally {
        setLoading(false);
      }
    };

    loadUsers();
  }, [authLoading, isAdmin]);

  const setRole = async (targetId, role) => {
    setError("");
    try {
      const ref = doc(db, "users", targetId);
      await updateDoc(ref, { role });
      setUsers((prev) =>
        prev.map((item) => (item.id === targetId ? { ...item, role } : item))
      );
    } catch (err) {
      console.error(err);
      setError("Failed to update user role.");
    }
  };

  if (authLoading) {
    return <div style={{ padding: "1.5rem" }}>Loading...</div>;
  }

  if (!isAdmin) {
    return (
      <div style={{ padding: "1.5rem" }}>
        <h1>Admin Users</h1>
        <p>You do not have access to this page.</p>
      </div>
    );
  }

  return (
    <div style={{ padding: "1.5rem" }}>
      <h1>Admin Users</h1>
      {error && <p style={{ color: "#b00020" }}>{error}</p>}
      {loading ? (
        <p>Loading users...</p>
      ) : users.length === 0 ? (
        <p>No users found.</p>
      ) : (
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={thStyle}>Name</th>
              <th style={thStyle}>Email</th>
              <th style={thStyle}>Role</th>
              <th style={thStyle}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map((item) => {
              const isSelf = user?.uid === item.id;
              return (
                <tr key={item.id}>
                  <td style={tdStyle}>{item.displayName || "-"}</td>
                  <td style={tdStyle}>{item.email || "-"}</td>
                  <td style={tdStyle}>{item.role || "teacher"}</td>
                  <td style={tdStyle}>
                    <button
                      onClick={() => setRole(item.id, "admin")}
                      style={buttonStyle}
                      disabled={item.role === "admin"}
                    >
                      Make admin
                    </button>
                    <button
                      onClick={() => setRole(item.id, "teacher")}
                      style={{ ...buttonStyle, marginLeft: "0.5rem" }}
                      disabled={item.role !== "admin" || isSelf}
                      title={isSelf ? "You cannot demote yourself." : ""}
                    >
                      Make teacher
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}

const thStyle = {
  textAlign: "left",
  borderBottom: "1px solid #ddd",
  padding: "0.5rem",
};

const tdStyle = {
  borderBottom: "1px solid #eee",
  padding: "0.5rem",
  verticalAlign: "top",
};

const buttonStyle = {
  padding: "0.35rem 0.6rem",
  borderRadius: "4px",
  border: "1px solid #999",
  background: "#fff",
  cursor: "pointer",
};
